import { ColorCodeEnum } from 'libs/shared/enums';

export const TemperatureColorFahrenheitRules = [
  { min: -Infinity, max: -15, color: ColorCodeEnum.DiffFromNormalSB },
  { min: -15, max: -8, color: ColorCodeEnum.DiffFromNormalMB },
  { min: -8, max: -5, color: ColorCodeEnum.DiffFromNormalB },
  { min: -5, max: -3, color: ColorCodeEnum.DiffFromNormalSlightB },
  { min: -3, max: 3, color: ColorCodeEnum.DiffFromNormal },
  { min: 3, max: 5, color: ColorCodeEnum.DiffFromNormalSlightA },
  { min: 5, max: 8, color: ColorCodeEnum.DiffFromNormalA },
  { min: 8, max: 15, color: ColorCodeEnum.DiffFromNormalMA },
  { min: 15, max: Infinity, color: ColorCodeEnum.DiffFromNormalSA },
];

export const TemperatureColorCelsiusRules = [
  { min: -Infinity, max: -8.0, color: ColorCodeEnum.DiffFromNormalSB },
  { min: -8.0, max: -4.5, color: ColorCodeEnum.DiffFromNormalMB },
  { min: -4.5, max: -3.0, color: ColorCodeEnum.DiffFromNormalB },
  { min: -3.0, max: -1.5, color: ColorCodeEnum.DiffFromNormalSlightB },
  { min: -1.5, max: 1.5, color: ColorCodeEnum.DiffFromNormal },
  { min: 1.5, max: 3.0, color: ColorCodeEnum.DiffFromNormalSlightA },
  { min: 3.0, max: 4.5, color: ColorCodeEnum.DiffFromNormalA },
  { min: 4.5, max: 8.0, color: ColorCodeEnum.DiffFromNormalMA },
  { min: 8.0, max: Infinity, color: ColorCodeEnum.DiffFromNormalSA },
];

export const FeelsLikeColorFahrenheitRules = [
  {
    min: -Infinity,
    max: -7.0,
    color: ColorCodeEnum.ForecastValueFeelsLikeDarkBlue,
  },
  {
    min: -7.0,
    max: -3.0,
    color: ColorCodeEnum.ForecastValueFeelsLikeLightBlue,
  },
  { min: -3.0, max: 3.0, color: ColorCodeEnum.ForecastValueFeelsLikeWhite },
  { min: 3.0, max: 7.0, color: ColorCodeEnum.ForecastValueFeelsLikeLightRed },
  {
    min: 7.0,
    max: Infinity,
    color: ColorCodeEnum.ForecastValueFeelsLikeDarkRed,
  },
];

export const FeelsLikeColorCelsiusRules = [
  {
    min: -Infinity,
    max: -4.0,
    color: ColorCodeEnum.ForecastValueFeelsLikeDarkBlue,
  },
  { min: -4.0, max: -2, color: ColorCodeEnum.ForecastValueFeelsLikeLightBlue },
  { min: -2.0, max: 2.0, color: ColorCodeEnum.ForecastValueFeelsLikeWhite },
  { min: 2.0, max: 4.0, color: ColorCodeEnum.ForecastValueFeelsLikeLightRed },
  {
    min: 4.0,
    max: Infinity,
    color: ColorCodeEnum.ForecastValueFeelsLikeDarkRed,
  },
];

export const PrecipColorMmRules = [
  {
    min: 0.0,
    max: 0.0,
    color: ColorCodeEnum.PrecipAmountMMRange1,
  },
  { min: 0.0, max: 13, color: ColorCodeEnum.PrecipAmountMMRange2 },
  { min: 13, max: 25, color: ColorCodeEnum.PrecipAmountMMRange3 },
  { min: 25, max: 38, color: ColorCodeEnum.PrecipAmountMMRange4 },
  {
    min: 38,
    max: Infinity,
    color: ColorCodeEnum.PrecipAmountMMRange5,
  },
];

export const PrecipColorInchesRules = [
  {
    min: 0.0,
    max: 0.0,
    color: ColorCodeEnum.PrecipAmountInchRange1,
  },
  { min: 0.0, max: 0.5, color: ColorCodeEnum.PrecipAmountInchRange2 },
  { min: 0.5, max: 1, color: ColorCodeEnum.PrecipAmountInchRange3 },
  { min: 1, max: 1.5, color: ColorCodeEnum.PrecipAmountInchRange4 },
  {
    min: 1.5,
    max: Infinity,
    color: ColorCodeEnum.PrecipAmountInchRange5,
  },
];
